module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAYAAAB8ZH1oAAAAJklEQVR4AWP4/////P+EwXwGEAAxCChCAJAAXkWYijEV4VGMqQgAKKZzyXP/MYAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/down-caret.png
// module id = 2437
// module chunks = 1